import React from 'react';

export default function ArrowWhite({fill = "#FFFFFF"}) {
    return (
        <div className="btn-arrow">
            <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                    fill={fill}
                    d="M24.5639893,19 L26.9521116,19 L30.9973338,25.1216537 L26.9493623,31.2700005 L24.5639893,31.2700005 L28.6109479,25.1239623 L24.5639893,19 Z M19,19 L21.3879776,19 L25.4334892,25.1216537 L21.3849389,31.2700005 L19,31.2700005 L23.0469586,25.1239623 L19,19 Z"
                />
            </svg>
        </div>
    );
}